<template>
    <v-layout row wrap justify-center align-center fill-height login mx-0 my-0>
        <v-flex xs12 login__title>
            <a href="https://wiam.ru">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="30px"
                    height="30px"
                >
                    <path
                        d="M27.391,15.771 C26.469,15.771 25.663,15.287 25.199,14.559 L23.017,14.580 L21.358,14.596 C20.850,14.629 20.345,14.330 20.066,13.884 L19.317,12.683 L14.535,23.158 C14.289,23.699 13.752,24.044 13.165,24.044 C13.143,24.044 13.123,24.044 13.102,24.043 C12.490,24.017 11.954,23.622 11.744,23.042 L9.734,17.462 L7.216,17.462 L5.019,17.462 C4.551,18.169 3.755,18.636 2.849,18.636 C1.408,18.636 0.240,17.458 0.240,16.009 C0.240,14.559 1.408,13.383 2.849,13.383 C3.694,13.383 4.438,13.794 4.913,14.421 L7.174,14.421 L10.793,14.421 C11.429,14.421 11.995,14.822 12.212,15.423 L13.328,18.522 L17.740,8.859 C17.971,8.351 18.459,8.013 19.014,7.976 C19.560,7.940 20.095,8.213 20.390,8.685 L22.174,11.547 L23.070,11.538 L25.358,11.516 C25.836,10.913 26.564,10.518 27.391,10.518 C28.832,10.518 30.000,11.694 30.000,13.145 C30.000,14.595 28.832,15.771 27.391,15.771 ZM25.018,9.172 C22.983,5.518 19.104,3.041 14.655,3.041 C9.350,3.041 4.847,6.562 3.327,11.405 C3.167,11.388 3.012,11.356 2.849,11.356 C1.770,11.356 0.789,11.746 -0.000,12.373 C1.239,5.353 7.332,0.000 14.655,0.000 C20.581,0.000 25.693,3.508 28.091,8.562 C27.861,8.526 27.631,8.491 27.391,8.491 C26.520,8.491 25.714,8.749 25.018,9.172 ZM4.103,20.467 C6.079,24.317 10.062,26.960 14.655,26.960 C20.306,26.960 25.039,22.963 26.234,17.633 C26.607,17.730 26.989,17.799 27.391,17.799 C28.095,17.799 28.755,17.626 29.353,17.341 C28.231,24.502 22.077,30.000 14.655,30.000 C8.213,30.000 2.729,25.854 0.655,20.080 C1.311,20.439 2.051,20.663 2.849,20.663 C3.286,20.663 3.701,20.582 4.103,20.467 Z"
                        fill-rule="evenodd"
                        fill="#ffffff"
                    />
                </svg>
                WIAM
            </a>
        </v-flex>
        <v-flex login__form>
            <v-form ref="form" v-model="valid" lazy-validation>
                <loading v-if="!isHashConfirmed && !isHashConfirmedError" />
                <template v-if="isHashConfirmedError">
                    <h2>{{ errors }}</h2>
                </template>
                <template v-if="isHashConfirmed && !isPhoneConfirmed">
                    <h2 class="mb-4">Введите телефон</h2>
                    <v-text-field
                        v-model="newUser.phone"
                        :rules="rules.phone"
                        label="Телефон"
                        v-mask="'(###) ###-##-##'"
                        prefix="+7 "
                        :error-messages="errorMessages.phone"
                        :disabled="hasCode"
                        required
                    ></v-text-field>

                    <v-layout row wrap justify-space-between v-if="hasCode">
                        <v-flex shrink mt-0 pr-0>
                            <v-text-field
                                v-model="phoneCode"
                                label="Введите код"
                                v-mask="'######'"
                                class="login__phone"
                            ></v-text-field>
                        </v-flex>
                        <v-flex shrink mt-0 justify-end>
                            <v-btn
                                v-if="hasCode"
                                color="primary"
                                @click="confirmPhone"
                                class="ma-0 mt-2"
                            >Подтвердить</v-btn>
                        </v-flex>
                    </v-layout>

                    <strong v-if="errors">{{ errors }}</strong>
                    <p class="mt-0" v-if="hasCode">
                        Не получили код подтверждения?
                        <span
                            v-if="isCodeTimeout"
                        >Получить новый можно через {{ codeTimeout }} сек.</span>
                        <span v-else @click="getPhoneCode">
                            <strong>Выслать новый код</strong>
                        </span>
                    </p>

                    <v-btn
                        v-if="!hasCode"
                        color="primary"
                        @click="getPhoneCode"
                    >Получить код подтверждения</v-btn>
                </template>
                <template v-if="isPhoneConfirmed">
                    <h2 class="mb-4">Регистрация</h2>
                    <v-autocomplete
                        v-if="showMe"
                        v-model="newUser.role"
                        :rules="rules.rule"
                        :items="roles"
                        item-text="name"
                        item-value="value"
                        label="Роль"
                        :error-messages="errorMessages.rule"
                        required
                    ></v-autocomplete>

                    <v-text-field
                        v-model="newUser.full_name"
                        :rules="rules.name"
                        label="ФИО"
                        :error-messages="errorMessages.full_name"
                        required
                    ></v-text-field>

                    <v-text-field
                        v-model="newUser.email"
                        :rules="rules.email"
                        label="E-mail"
                        :error-messages="errorMessages.email"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="newUser.phone"
                        :rules="rules.phone"
                        label="Телефон"
                        v-mask="'(###) ###-##-##'"
                        prefix="+7 "
                        :error-messages="errorMessages.phone"
                        disabled
                        required
                    ></v-text-field>

                    <v-text-field
                        label="Пароль"
                        v-model="newUser.password"
                        hint="Не меньше 6 символов"
                        min="6"
                        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                        @click:append="showPassword = !showPassword"
                        required
                        :type="showPassword ? 'text' : 'password'"
                    ></v-text-field>

                    <v-layout row wrap register__form-accept>
                        <v-flex xs1>
                            <v-checkbox color="primary" class="mt-0 pt-0"></v-checkbox>
                        </v-flex>
                        <v-flex xs11 pl-3>
                            Я ознакомлен и согласен с
                            <a
                                href="#"
                                taget="_blank"
                            >политикой обработки персональных данных</a> и присоединяюсь к
                            <a href="#" target="_blank">регламенту ЭДО</a>
                        </v-flex>
                    </v-layout>

                    <strong v-if="errors">{{ errors }}</strong>

                    <v-btn
                        color="primary"
                        @click="validate"
                        class="mt-4"
                        :disabled="!isValid"
                    >Зарегистрироваться</v-btn>
                </template>
            </v-form>

            <loading class="loader--absolute" v-if="disableLoginForm" />
        </v-flex>
    </v-layout>
</template>

<script>
import {
    AUTH_REQUEST,
    AUTH_SUCCESS,
    AUTH_LOGOUT
} from "../../store/actions/auth";
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import roles from "@/utils/data/roles";
import { mask } from "vue-the-mask";
import formatPhone from "@/mixins/filters/formatPhone";

export default {
    name: "Cabinet",
    directives: { mask },
    mixins: [formatPhone],
    data: () => ({
        email: "",
        phone: "",
        company: {},
        password: "",
        isPasswordRecovery: false,
        isHasCode: false,
        fullname: "",
        // old
        hash: ".",
        isHashConfirmed: false,
        isHashConfirmedError: false,
        isPhoneConfirmed: false,
        isCabinetExist: null,
        disableLoginForm: false,
        // register
        showMe: window.showMe,
        valid: true,
        phoneConfirmed: false,
        codeTimeout: 0,
        isCodeTimeout: true,
        hasCode: false,
        phoneCode: "",
        phoneHash: "",
        errors: null,
        errorMessages: {
            full_name: "",
            email: "",
            phone: "",
            password: ""
        },
        disableRegisterForm: false,
        newUser: {
            full_name: "",
            email: "",
            phone: "",
            role: 10,
            password: ""
        },
        showPassword: false,
        roles,
        rules
    }),
    computed: {
        isValid() {
            if (this.newUser.full_name !== "" && this.newUser.password !== "") {
                return true;
            }
            return false;
        },
        isValidRecovery() {
            if (this.phone && !this.fullname) {
                return true;
            }
            return false;
        }
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.registerNewUser();
            }
        },
        registerNewUser() {
            this.disableRegisterForm = true;

            const data = this.newUser;
            data.phone_confirm_code = this.phoneCode;
            data.hash = this.phoneHash;
            data.urlHash = this.hash;

            apiCallTrue({
                url: "v1/users/registration",
                method: "POST",
                data
            })
                .then(response => {
                    this.autoAuth(response);
                })
                .catch(error => {
                    // this.errors = error.validation;
                    // this.errorMessages = error.validation;
                    this.errors = error.message;
                    this.disableRegisterForm = false;
                });
        },
        autoAuth(response) {
            if (response.data.result) {
                this.$store
                    .dispatch(AUTH_REQUEST, {
                        email: this.newUser.email,
                        password: this.newUser.password
                    })
                    .then(() => {
                        // if (this.newUser.role === 10)
                        switch (this.newUser.role) {
                            case 10:
                                this.$router.push("/company");
                                break;
                            case 150:
                                this.$router.push("/tenders");
                                break;
                            default:
                                this.$router.push("/");
                        }
                    });
            }
        },
        async checkHash(hash) {
            this.disableLoginForm = true;
            console.log(hash, "hash");

            //     const axiosConfig = {
            //     method: "POST",
            //     // url: `https://api.cryptodok.wiam.ru/${url}`,
            //     url: `http://api.localdoc.ru/v1/users/cabinet-check-hash`,
            //     data: { hash },
            //     headers: {
            //         "Content-Type": "application/json"
            //     },
            // };

            // axios(axiosConfig)
            //     .then(response => {
            //             if (response.data.result) {
            //                 this.disableLoginForm = false;

            //                 setTimeout(() => {
            //                     this.isHashConfirmed = response.data.result;
            //                 }, 100);
            //         } else {
            //             console.log(response.data, 2);
            //         }
            //     })
            //     .catch(error => {
            //         this.errors = error.response.data.message;
            //             // setTimeout(() => {
            //             //     this.hash = null;
            //             // }, 2000);
            //             // setTimeout(() => {
            //             this.disableLoginForm = false;
            //             this.isHashConfirmedError = true;
            //             // }, 100);
            //     });

            await apiCallTrue({
                url: `v1/users/cabinet-check-hash`,
                method: "POST",
                data: { hash }
            })
                .then(response => {
                    console.log(response, "hash response");
                    if (response.data.result) {
                        this.disableLoginForm = false;

                        setTimeout(() => {
                            this.isHashConfirmed = response.data.result;
                        }, 100);
                    }
                })
                .catch(error => {
                    this.errors = error.message;
                    this.disableLoginForm = false;
                    this.isHashConfirmedError = true;
                });
        },
        getPhoneCode() {
            this.errors = null;
            apiCallTrue({
                url: "v1/users/cabinet-exist",
                method: "POST",
                data: {
                    phone: this.newUser.phone,
                    hash: this.hash
                }
            })
                .then(response => {
                    this.phoneHash = response.data.data.hash;
                    this.phoneCode = "";
                    this.isCabinetExist = response.data.data.exist;

                    this.hasCode = true;
                    this.codeTimeout = 120;
                    this.isCodeTimeout = true;

                    this.getCodeTimeout();
                })
                .catch(error => {
                    this.errors = error.message;
                });
        },
        confirmPhone() {
            const data = {
                phone_confirm_code: this.phoneCode,
                hash: this.phoneHash,
                phone: this.newUser.phone,
                urlHash: this.hash
            };

            apiCallTrue({
                url: "v1/users/phone-confirmation",
                method: "POST",
                data
            })
                .then(response => {
                    const confirm = response.data.result;

                    if (confirm && !this.isCabinetExist) {
                        this.isPhoneConfirmed = confirm;
                        this.$refs.form.resetValidation();
                        this.errors = null;
                    }
                    if (confirm && this.isCabinetExist) {
                        this.$store
                            .dispatch(AUTH_SUCCESS, response)
                            .then(() => {
                                localStorage.removeItem("cabinet_hash");
                                this.$router.push("/company");
                            });
                    }
                    if (!confirm) {
                        this.errors = "Unknown error";
                    }
                })
                .catch(error => {
                    this.errors = error.message;
                });
        },
        getCodeTimeout() {
            if (this.codeTimeout <= 0) return false;
            const codeInterval = setInterval(() => {
                this.codeTimeout--;
            }, 1000);

            setTimeout(() => {
                clearInterval(codeInterval);
                this.isCodeTimeout = false;
            }, 60000);
            return true;
        }
    },
    mounted() {
        const urlHash = this.$route.query.hash;
        const localHash = localStorage.getItem("cabinet_hash");
        // localStorage.removeItem("user-token");
        this.$store.dispatch(AUTH_LOGOUT);

        if ((urlHash && localHash) || (urlHash && !localHash)) {
            this.hash = urlHash;
            localStorage.setItem("cabinet_hash", urlHash);
            this.checkHash(this.hash);
        }
        if (!urlHash && localHash) {
            this.hash = localHash;
            this.checkHash(this.hash);
        }

        // this.hash = this.$route.query.hash || localStorage.getItem('cabinet_hash');
    }
};
</script>

<style lang="scss" scoped>
.login {
    background: url(../../assets/images/login.jpg) no-repeat center top;
    background-size: cover;
    position: relative;
    align-content: center;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
    }
    &__title {
        a {
            color: #fff;
            text-align: center;
            font-size: 25px;
            border: 0 !important;
            position: relative;
            margin-bottom: 60px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            font-weight: bold;
        }

        svg {
            margin-right: 16px;
        }
    }

    &__form {
        background: #fff;
        box-shadow: 0 0 20px #000;
        border-radius: 4px;
        border: 1px solid #eee;
        padding: 35px 40px 20px !important;
        max-width: 400px;
        text-align: center;
        position: relative;

        p {
            font-size: 0.9em;
            color: #aaa;
        }

        &-recovery {
            text-align: right;
            margin-top: -16px;
            position: relative;
            z-index: 1;

            em {
                color: #aaa;
                font-style: italic;
                font-size: 13px;
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }
    &__fullname {
        height: 0px;
        overflow: hidden;
        opacity: 0;
    }

    &__phone {
        max-width: 155px;
    }
}
</style>
